import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useAssignPermission = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [assignPermissionLoading, setAssignPermissionLoading] = useState(false);

  const assignPermissionRequest = ({ permissionGuid, userGuid }, onSuccess) => {
    setAssignPermissionLoading(true);
    axiosClient
      .put(`SettingAccount/User/Permission/Assignment`, {
        permissionGuid,
        userGuid,
      })
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`با موفقیت انجام شد`, {
            variant: 'success',
          });

          onSuccess?.();
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setAssignPermissionLoading(false));
  };

  return { assignPermissionRequest, assignPermissionLoading };
};

export default useAssignPermission;
